import { StringSchema } from 'yup'

function validateCPF(this: StringSchema, message: string) {
  return this.test('validateCPF', message, (value) => {
    const cpf = String(value).replace(/[^\d]+/g, '')
    if (cpf.length !== 11 || /^(\d)\1+$/.test(cpf)) return false
    let sum = 0
    for (let i = 0; i < 9; i += 1) {
      sum += +cpf.charAt(i) * (10 - i)
    }
    let rest = 11 - (sum % 11)
    if (rest === 10 || rest === 11) rest = 0
    if (rest !== +cpf.charAt(9)) return false
    sum = 0
    for (let i = 0; i < 10; i += 1) {
      sum += +cpf.charAt(i) * (11 - i)
    }
    rest = 11 - (sum % 11)
    if (rest === 10 || rest === 11) rest = 0
    if (rest !== +cpf.charAt(10)) return false
    return true
  })
}

export default validateCPF
